// extracted by mini-css-extract-plugin
export default {"camps-container":"styles_camps-container__FjBUD","camps-container__text":"styles_camps-container__text__ObFBq","cover":"styles_cover__7780-"};